import { SELECIONAR_ASSENTO_ITINERARIO_VOLTA } from '../types'

export default function selecionarAssentoItinerarioVolta (assento, fileira) {
  return {
    type: SELECIONAR_ASSENTO_ITINERARIO_VOLTA,
    payload: { assento, fileira }
  }
}
